//"use client";
import "./syntax-highlighter.css";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Prism } from "react-syntax-highlighter";
import {
  oneLight,
  vscDarkPlus,
} from "react-syntax-highlighter/dist/cjs/styles/prism";

export const SyntaxHighlighter = ({
  children,
  language = "sh",
  size = "sm",
  showLineNumbers = true,
  className,
  lineNumberStyle,
  customStyle,
}: {
  children: string | string[];
  language?: string;
  size?: "xs" | "sm";
  style?: "light" | "dark";
  showLineNumbers?: boolean;
  className?: string;
  lineNumberStyle?: React.CSSProperties;
  customStyle?: React.CSSProperties;
}) => {
  const { resolvedTheme } = useTheme();
  // fixes hard refresh issue
  const [prismTheme, setPrismTheme] = useState(vscDarkPlus);
  useEffect(() => {
    if (resolvedTheme === "dark") {
      setPrismTheme(vscDarkPlus);
      return;
    }
    setPrismTheme(oneLight);
  }, [resolvedTheme]);
  return (
    <Prism
      key={`${resolvedTheme}-${language}`}
      codeTagProps={{
        // @ts-ignore
        "data-size": size,
        "data-type": "syntax-highlighter",
      }}
      language={language}
      style={prismTheme}
      showLineNumbers={showLineNumbers}
      lineNumberStyle={Object.assign(
        {
          minWidth: size === "xs" ? "46px" : "47px",
          paddingRight: "18px",
        },
        lineNumberStyle,
      )}
      customStyle={Object.assign(
        {
          margin: 0,
          paddingTop: "14px",
          paddingLeft: showLineNumbers ? "0" : "20px",
          paddingBottom: "14px",
          paddingRight: "20px",
          backgroundColor: "inherit",
        },
        customStyle,
      )}
      className={className}
    >
      {children}
    </Prism>
  );
};
